import * as yup from 'yup'
import { HOLIDAY_OPTIONS } from '../../types/utils'
import i18n from '@/configs/i18n'
export const holidaySchema = yup.object().shape({
    data: yup.array().of(
        yup.object().shape({
            holiday_date: yup.string().required('Ngày nghỉ là bắt buộc'),
            holiday_name: yup
                .string()
                .required('Tên ngày nghỉ là bắt buộc')
                .oneOf(
                    HOLIDAY_OPTIONS(i18n.t).map((option) => option.value),
                    'Tên ngày nghỉ là bắt buộc'
                ),
            holiday_work_n_day: yup
                .number()
                .required('Số ngày làm việc là bắt buộc')
                .oneOf([0, 1, 2], 'Giá trị hợp lệ là 0, 1, hoặc 2'),
        })
    ),
})
export const holidayUpdateSchema = yup.object().shape({
    holiday_date: yup.string().required('Ngày nghỉ là bắt buộc'),
    holiday_name: yup
        .string()
        .required('Tên ngày nghỉ là bắt buộc')
        .oneOf(
            HOLIDAY_OPTIONS(i18n.t).map((option) => option.value),
            'Tên ngày nghỉ là bắt buộc'
        ),
    holiday_work_n_day: yup
        .number()
        .required('Số ngày làm việc là bắt buộc')
        .oneOf([0, 1, 2], 'Giá trị hợp lệ là 0, 1, hoặc 2'),
})
